export const PATHS = {
    // ----------- external pages -----------

    home: "/Home",
    privacy_policy: "/privacy_policy",
    terms_and_condition: "/terms_and_condition",
    ClubSupportProgram: "/ClubSupportProgram",
    login_club: "/LoginClub", // New path for club login with code

    // ----------- internal pages -----------

    club_management: "/club-management",

    // media: "/media",
    // media_detail: "/media/:id",

    // ----------- next phase pages -----------

    // media: "/media",
    // media_detail: "/media/:id",
    // news_detail: "/news/:id",

    // ----------- not found page -----------
    not_found: "*",
};